<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/logo-white.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img src="img/brand/logo.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">회사소개</span>
                    </a>
                    <router-link to="/history" class="dropdown-item">기업연혁</router-link>
                    <router-link to="/introduce" class="dropdown-item">기업소개</router-link>
                    <router-link to="/benefit" class="dropdown-item">복리후생</router-link>
                    <router-link to="/location" class="dropdown-item">오시는 길</router-link>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">사업소개</span>
                    </a>
                    <router-link to="/buscivil" class="dropdown-item">토목</router-link>
                    <router-link to="/bussewage" class="dropdown-item">상하수도</router-link>
                    <router-link to="/busess" class="dropdown-item">비굴착공법</router-link>
                    <router-link to="/reference" class="dropdown-item">주요시공사</router-link>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">고객센터</span>
                    </a>
                    <router-link to="/qanda" class="dropdown-item">Q&A</router-link>
                    <router-link to="/customer" class="dropdown-item">견적문의</router-link>
                </base-dropdown>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
